import { render, staticRenderFns } from "./PageSkeletonTwo.vue?vue&type=template&id=0b6c9604&scoped=true"
var script = {}
import style0 from "./PageSkeletonTwo.vue?vue&type=style&index=0&id=0b6c9604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c9604",
  null
  
)

export default component.exports